import React from 'react';
import './ResubmissionList.scss';
import PropTypes from 'prop-types';

const ResubmissionList = props => (
  <div className="resubmission-list">
    <div className="resubmission-list__top-section">
      <div className="resubmission-list__header">{props.title}</div>

      <div className="resubmission-list__header-value">{props.subTitle}</div>
    </div>

    {props.list.length > 0 && <hr className="resubmission-list__hr" />}

    {props.list.map(item => (
      <div key={item.number} className="resubmission-list__list-item">
        <span className="font-bold">{item.number}</span>
        <div>{item.value}</div>
      </div>
    ))}
  </div>
);
ResubmissionList.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.number.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default ResubmissionList;
